/* Saints Reserve theme script. One small file, no library.
   Drawers, the cart (AJAX, drawer, free-shipping bar, add-on), the product page
   (variants, gallery, sticky buy), predictive search, reveals, tilt. */
(() => {
  'use strict';
  const SR = window.SR || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (SR.motion === false) document.documentElement.dataset.motion = 'off';

  // A Shopify CDN picture at a size: the image service takes width, height and crop as parameters.
  const sized = (url, w, h) => `${url}${url.includes('?') ? '&' : '?'}width=${w}&height=${h}&crop=center`;

  // ─── Money ───────────────────────────────────────────────
  const money = (cents) => {
    const fmt = SR.money || '${{amount}}';
    const n = (cents / 100);
    const amount = fmt.includes('no_decimals') ? Math.round(n).toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  };

  // ─── Toast ───────────────────────────────────────────────
  let toastTimer;
  const toast = (text) => {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = text; el.hidden = false; requestAnimationFrame(() => el.classList.add('is-shown'));
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.classList.remove('is-shown'); setTimeout(() => (el.hidden = true), 400); }, 2600);
  };

  // ─── Drawers ─────────────────────────────────────────────
  const overlay = $('[data-overlay]');
  let openDrawer = null, lastFocus = null;
  const open = (name) => {
    const d = $(`[data-drawer="${name}"]`); if (!d) return;
    if (openDrawer && openDrawer !== d) close(false);
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden'; openDrawer = d;
    const f = $('input:not([type=hidden]), button, a', d); setTimeout(() => f?.focus({ preventScroll: true }), 300);
  };
  const close = (restore = true) => {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open'); openDrawer.setAttribute('aria-hidden', 'true'); overlay?.classList.remove('is-open');
    document.body.style.overflow = ''; openDrawer = null;
    if (restore && lastFocus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); open(o.dataset.open); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
  });
  overlay?.addEventListener('click', () => close());
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  // Tab stays inside an open drawer, as it would in a dialog.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !openDrawer) return;
    const f = $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', openDrawer).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!openDrawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ─── Header: glass over the hero until the page scrolls ──
  const headerWrap = $('[data-header]');
  if (headerWrap) {
    const onScroll = () => headerWrap.classList.toggle('is-scrolled', scrollY > 24);
    onScroll(); addEventListener('scroll', onScroll, { passive: true });
    // How tall the header is, for whatever is held beneath it: the collection's filter bar, the product page's columns.
    const measure = () => document.documentElement.style.setProperty('--header-total', `${Math.round(headerWrap.getBoundingClientRect().height)}px`);
    measure(); addEventListener('resize', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(headerWrap);
  }

  // ─── Cart ────────────────────────────────────────────────
  const cart = {
    async fetch() { const r = await fetch(SR.routes.cartJson, { headers: { Accept: 'application/json' } }); return r.json(); },
    async add(items) {
      const r = await fetch(SR.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || SR.strings.error); }
      return r.json();
    },
    async change(line, quantity) {
      const r = await fetch(SR.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      return r.json();
    },
    async note(note) { await fetch(SR.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) }); },
  };

  // The note under the subtotal says what standard shipping costs (theme setting "Standard shipping
  // costs"), or that this order ships free: no surprise at checkout. With the setting empty the note
  // keeps its plain words.
  const renderShipNote = (root, c) => {
    const note = $('[data-ship-note]', root); if (!note || !SR.shipCost) return;
    const t = SR.threshold || 0;
    note.textContent = !t ? SR.strings.shipNoteFlat.replace('{{ cost }}', SR.shipCost)
      : c.total_price >= t ? SR.strings.shipNoteFree
        : SR.strings.shipNoteCost.replace('{{ cost }}', SR.shipCost).replace('{{ amount }}', money(t).replace(/[.,]00$/, ''));
  };
  const renderShipbar = (root, c) => {
    renderShipNote(root, c);
    const bar = $('[data-shipbar]', root); if (!bar) return;
    const t = SR.threshold || 0; if (!t) { bar.hidden = true; return; }
    bar.hidden = c.item_count === 0;
    const left = Math.max(0, t - c.total_price);
    const p = Math.min(100, Math.round((c.total_price / t) * 100));
    bar.style.setProperty('--p', p + '%');
    bar.classList.toggle('is-unlocked', left === 0);
    $('[data-shipbar-text]', bar).textContent = left === 0 ? SR.strings.unlocked : SR.strings.away.replace('{{ amount }}', money(left));
  };

  const lineHtml = (item, i) => `
    <div class="line" data-line="${i + 1}" data-key="${item.key}">
      <a class="line__pic" href="${item.url}">${item.image ? `<img src="${sized(item.image, 160, 213)}" width="80" height="107" alt="">` : ''}</a>
      <div class="line__body">
        <a class="line__title" href="${item.url}">${item.product_title}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="line__meta">${item.variant_title}</div>` : ''}
        ${item.selling_plan_allocation ? `<div class="line__meta">${item.selling_plan_allocation.selling_plan.name}</div>` : ''}
        <div class="line__row">
          <div class="qty" data-qty>
            <button type="button" data-qty-minus aria-label="Decrease">−</button>
            <input type="number" min="0" value="${item.quantity}" aria-label="Quantity" data-qty-input>
            <button type="button" data-qty-plus aria-label="Increase">+</button>
          </div>
          <div class="line__price">${money(item.final_line_price)}${item.original_line_price > item.final_line_price ? ` <s class="muted small">${money(item.original_line_price)}</s>` : ''}</div>
        </div>
        <button type="button" class="line__remove" data-remove>${root_strings().remove}</button>
      </div>
    </div>`;
  const root_strings = () => ({ remove: $('[data-cart-root]')?.dataset.remove || 'Remove' });

  const renderCart = (c) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.dataset.count = c.item_count; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
    $$('[data-cart-root]').forEach((root) => {
      const lines = $('[data-lines]', root), empty = $('[data-empty]', root), foot = $('[data-cart-foot]', root);
      if (lines) lines.innerHTML = c.items.map(lineHtml).join('');
      if (empty) empty.hidden = c.item_count > 0;
      if (foot) foot.hidden = c.item_count === 0;
      // After every discount: what the customer will be asked for, before shipping and tax.
      $$('[data-subtotal]', root).forEach((el) => (el.textContent = money(c.total_price)));
      const disc = $('[data-discounts]', root);
      if (disc) { const total = c.total_discount; disc.hidden = !total; if (total) $('[data-discount-amount]', disc).textContent = '−' + money(total); }
      renderShipbar(root, c);
      const addon = $('[data-addon]', root);
      if (addon) { const id = Number(addon.dataset.variant); addon.hidden = c.item_count === 0 || c.items.some((i) => i.variant_id === id); }
    });
  };

  const refreshCart = async () => { const c = await cart.fetch(); renderCart(c); return c; };

  document.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-line]');
    if (line) {
      const n = Number(line.dataset.line); const input = $('[data-qty-input]', line);
      if (e.target.closest('[data-qty-minus]')) { renderCart(await cart.change(n, Math.max(0, Number(input.value) - 1))); return; }
      if (e.target.closest('[data-qty-plus]')) { renderCart(await cart.change(n, Number(input.value) + 1)); return; }
      if (e.target.closest('[data-remove]')) { line.style.opacity = '.4'; renderCart(await cart.change(n, 0)); return; }
    }
    const addon = e.target.closest('[data-addon-add]');
    if (addon) {
      addon.classList.add('is-loading'); addon.disabled = true;
      try { await cart.add([{ id: Number(addon.dataset.variant), quantity: 1 }]); await refreshCart(); toast(SR.strings.added); }
      catch (err) { toast(err.message); }
      addon.classList.remove('is-loading'); addon.disabled = false;
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]'); if (!input) return;
    const line = input.closest('[data-line]'); renderCart(await cart.change(Number(line.dataset.line), Math.max(0, Number(input.value) || 0)));
  });
  let noteTimer;
  document.addEventListener('input', (e) => { const n = e.target.closest('[data-cart-note]'); if (!n) return; clearTimeout(noteTimer); noteTimer = setTimeout(() => cart.note(n.value), 500); });

  // Product forms: add without leaving the page, then open the drawer.
  const addFromForm = async (form) => {
    const btn = $('[data-add]', form); const id = Number(new FormData(form).get('id')); const qty = Number(new FormData(form).get('quantity') || 1);
    if (btn?.disabled) return;
    if (!id) { form.dispatchEvent(new CustomEvent('sr:choose', { bubbles: true })); return; }
    btn?.classList.add('is-loading'); btn && (btn.disabled = true);
    try {
      await cart.add([{ id, quantity: qty }]);
      await refreshCart();
      if (SR.drawer && $('[data-drawer="cart"]')) open('cart'); else toast(SR.strings.added);
    } catch (err) { toast(err.message || SR.strings.error); }
    btn?.classList.remove('is-loading'); btn && (btn.disabled = false);
  };
  // ONE ADD IS ONE ADD TO CART. Shopify's tracking counts a submit of the product form and the add
  // request itself, so a tap that did both told Meta "AddToCart" twice (found 2026-10-09: every cart
  // counted double since the theme went live). A tap on the button is therefore handled here and never
  // becomes a form submit; only the add request is left to be counted. Without JavaScript the button is
  // still an ordinary submit. A submit by the Enter key (rare) is still caught below.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('form[data-product-form] [data-add]'); if (!btn) return;
    e.preventDefault();
    addFromForm(btn.closest('form'));
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  if ($('[data-cart-root]')) refreshCart().catch(() => {});

  // ─── Product page ────────────────────────────────────────
  $$('[data-product]').forEach((root) => {
    const data = JSON.parse($('[data-product-json]', root)?.textContent || 'null'); if (!data) return;
    const form = $('form[data-product-form]', root); const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), addBtn = $('[data-add]', root), addText = $('[data-add-text]', addBtn);
    const stickyPrice = $('[data-sticky-price]'), stickyBtn = $('[data-sticky-add]');
    const strings = JSON.parse(root.dataset.strings || '{}');
    const express = $('[data-express]', root);
    const optGroups = $$('.opt', root);
    const selected = () => optGroups.map((o) => $('input:checked', o)?.value);
    // A product with no choices (a card pack, a keychain) has no option controls: its one variant is the
    // selection. Comparing its "Default Title" option against an empty selection found nothing, which
    // is why the card pack said Unavailable.
    const findVariant = () => {
      if (!optGroups.length) return data.variants.find((v) => String(v.id) === String(idInput.value)) || data.variants[0];
      const s = selected();
      return data.variants.find((v) => v.options.every((o, i) => o === s[i]));
    };
    const markUnavailable = () => {
      const s = selected();
      optGroups.forEach((opt, oi) => $$('label', opt).forEach((label) => {
        const input = $(`#${CSS.escape(label.htmlFor)}`, opt); const trial = [...s]; trial[oi] = input.value;
        // A choice not made yet counts as any: with no size chosen, a colour is unavailable only when
        // every size of it is.
        const open = data.variants.some((v) => v.available && v.options.every((o, i) => trial[i] === undefined || o === trial[i]));
        label.classList.toggle('is-unavailable', !open);
      }));
    };
    // ONE state for every buy control: the main button, the sticky button, the express buttons and the
    // variant the form will send. A choice that does not exist sends nothing at all.
    // NO SIZE IS CHOSEN FOR THE SHOPPER (owner, 2026-10-10). Small used to be chosen before anyone
    // looked, so an untouched tap put a Small in the bag, and the bag cannot change a size. Until every
    // choice is made the buttons say "Choose a size" and a tap shows the sizes; nothing is added.
    const unchosen = () => optGroups.filter((o) => !o.hidden && !$('input:checked', o));
    const setBuyState = (v) => {
      const ask = !v && unchosen().length > 0;
      const ok = Boolean(v && v.available);
      const label = ask ? (strings.choose || strings.add) : !v ? strings.unavailable : v.available ? strings.add : strings.sold_out;
      addBtn.disabled = !ok && !ask; addText.textContent = label;
      addBtn.classList.toggle('is-asking', ask);
      if (stickyBtn) { stickyBtn.disabled = !ok && !ask; $('.btn__text', stickyBtn).textContent = label; }
      if (express) express.hidden = !ok;
      idInput.value = v ? v.id : '';
      root.dataset.variant = v ? v.id : '';
      // Shopify's express buttons listen for this to follow the chosen variant.
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const apply = () => {
      const v = findVariant();
      optGroups.forEach((o) => { const b = $('[data-opt-value]', o); if (b) b.textContent = $('input:checked', o)?.value || ''; });
      markUnavailable();
      setBuyState(v);
      const url = new URL(location.href);
      if (!v) { url.searchParams.delete('variant'); history.replaceState(null, '', url); return; }
      priceEl.textContent = money(v.price); if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (compareEl) { compareEl.hidden = !(v.compare_at_price > v.price); compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (v.featured_media) { const slide = $(`[data-media-id="${v.featured_media.id}"]`, root); if (slide) showSlide(slide); }
      url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    // Gallery: swipe on a phone, thumbnails on a desktop.
    const track = $('[data-gallery-track]', root); const slides = $$('.gallery__slide', root); const dots = $$('[data-dot]', root); const thumbs = $$('[data-thumb]', root);
    const mark = (i) => { dots.forEach((d, j) => d.setAttribute('aria-current', String(i === j))); thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j))); slides.forEach((s, j) => s.classList.toggle('is-active', i === j)); };
    const showSlide = (slide) => { const i = slides.indexOf(slide); if (i < 0) return; mark(i); if (matchMedia('(max-width: 899px)').matches) slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); };
    dots.forEach((d, i) => d.addEventListener('click', () => showSlide(slides[i])));
    thumbs.forEach((t, i) => t.addEventListener('click', () => showSlide(slides[i])));
    if (track && slides.length > 1) {
      const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > .6) mark(slides.indexOf(en.target)); }), { root: track, threshold: [.6] });
      slides.forEach((s) => io.observe(s));
    }
    mark(0);

    root.addEventListener('change', (e) => { if (e.target.closest('.opt')) apply(); });
    // A link that names a variant chooses its size (a link from the bag, a shared link). An ad's link
    // does not: a catalogue card names whichever size the feed listed, not one the shopper chose.
    const fromAd = /[?&](fbclid|utm_medium=paid|utm_source=(facebook|instagram|fb|ig|meta))/i.test(location.search);
    const linked = new URL(location.href).searchParams.get('variant');
    const linkedVariant = linked && !fromAd ? data.variants.find((v) => String(v.id) === linked) : null;
    if (linkedVariant) optGroups.forEach((o, i) => { const input = $$('input', o).find((x) => x.value === linkedVariant.options[i]); if (input) input.checked = true; });
    apply();
    // Asked for a size: bring the sizes into view and mark them for a moment.
    root.addEventListener('sr:choose', () => {
      const group = unchosen()[0]; if (!group) return;
      group.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      group.classList.remove('is-asked'); void group.offsetWidth; group.classList.add('is-asked');
      setTimeout(() => group.classList.remove('is-asked'), 1800);
    });

    // Sticky buy bar: there whenever the real button is not on the screen, above it or below it. On a
    // phone the button starts below the first screen, so the bar is there from the start (2026-10-10).
    const sticky = $('[data-sticky-buy]');
    if (sticky && addBtn) {
      new IntersectionObserver((es) => es.forEach((en) => sticky.classList.toggle('is-shown', !en.isIntersecting)), { threshold: 0 }).observe(addBtn);
      stickyBtn?.addEventListener('click', () => addFromForm(form));
    }
  });

  // ─── Predictive search ───────────────────────────────────
  // "hoodie" is a sweatshirt here, so a few synonyms are tried too.
  // Two questions are asked at once. The search page's JSON view
  // (templates/search.suggest.liquid) answers with every design whose TITLE
  // carries the words, up to 48, so "mary" lists all of Mary's designs and
  // nothing whose description merely mentions her; Shopify's predictive search
  // (ten at most, typo tolerant, and the source of the collections and the
  // suggested terms) is the fallback when no title matches. A collection whose
  // products have all been made inactive is not offered: the storefront's own
  // products.json for it says it is empty.
  const SYN = { hoodie: 'sweatshirt', hoodies: 'sweatshirt', sweater: 'sweatshirt', tee: 'shirt', tshirt: 'shirt', 't-shirt': 'shirt', 'mary': 'mother mary', 'jesus': 'sacred heart' };
  const PREDICT_MAX = 10;
  const collectionHasProducts = new Map();
  const collectionLive = async (c, signal) => {
    const handle = c.handle || (c.url || '').split('?')[0].split('/').pop();
    if (!collectionHasProducts.has(handle)) {
      collectionHasProducts.set(handle, fetch(`${SR.routes.root}collections/${handle}/products.json?limit=1`, { signal, headers: { Accept: 'application/json' } })
        .then((r) => r.ok ? r.json() : { products: [] }).then((j) => (j.products || []).length > 0).catch(() => true));
    }
    return collectionHasProducts.get(handle);
  };
  $$('[data-predictive]').forEach((box) => {
    const input = $('input[type="search"]', box), out = $('[data-suggest]', box); let ctrl, timer;
    const run = async () => {
      const q = input.value.trim(); if (q.length < 2) { out.innerHTML = ''; return; }
      ctrl?.abort(); ctrl = new AbortController();
      const opts = { signal: ctrl.signal, headers: { Accept: 'application/json' } };
      try {
        const url = `${SR.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=${PREDICT_MAX}&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor`;
        const byTitle = (term) => fetch(`${SR.routes.search}?q=${encodeURIComponent(`title:${term}`)}&type=product&options[prefix]=last&view=suggest`, opts)
          .then((r) => (r.ok ? r.json() : { count: 0, products: [] })).catch((e) => { if (e.name === 'AbortError') throw e; return { count: 0, products: [] }; });
        const [j, titled] = await Promise.all([fetch(url, opts).then((r) => r.json()), byTitle(q)]);
        // Predictive prices are dollars as text; the suggest view's are cents. One shape here.
        const fromPredictive = (list) => (list || []).map((p) => ({ title: p.title, url: p.url, cents: Math.round(Number(p.price) * 100), image: p.featured_image ? sized(p.featured_image.url, 104, 139) : null }));
        const fromTitled = (view) => (view.products || []).map((p) => ({ title: p.title, url: p.url, cents: p.price, image: p.image }));
        let products = fromTitled(titled), count = titled.count || products.length, term = q;
        if (!products.length) { products = fromPredictive(j.resources.results.products); count = products.length; }
        const syn = SYN[q.toLowerCase()];
        if (!products.length && syn) {
          term = syn;
          const [r2, titled2] = await Promise.all([fetch(`${SR.routes.predictive}?q=${encodeURIComponent(syn)}&resources[type]=product&resources[limit]=${PREDICT_MAX}`, opts).then((r) => r.json()), byTitle(syn)]);
          products = fromTitled(titled2); count = titled2.count || products.length;
          if (!products.length) { products = fromPredictive(r2.resources.results.products); count = products.length; }
        }
        // Ten of each come back; the designs are the point, so the terms and collections above and below them stay short.
        const colsAll = (j.resources.results.collections || []).slice(0, 4), terms = (j.resources.results.queries || []).slice(0, 5);
        const live = await Promise.all(colsAll.map((c) => collectionLive(c, ctrl.signal)));
        const cols = colsAll.filter((c, i) => live[i]);
        const seeAll = `${SR.routes.search}?q=${encodeURIComponent(term)}&type=product&options[prefix]=last`;
        out.innerHTML = `
          ${terms.length ? `<div class="suggest__terms">${terms.map((t) => `<a href="${t.url}">${t.styled_text}</a>`).join('')}</div>` : ''}
          ${products.length ? `<div><div class="suggest__head">${box.dataset.products}</div>${products.map((p) => `<a class="suggest__item" href="${p.url}">${p.image ? `<img src="${p.image}" alt="" width="52" height="69" loading="lazy">` : '<span></span>'}<span><b>${p.title}</b><span>${money(p.cents)}</span></span></a>`).join('')}${count > products.length || products.length > 4 ? `<a class="suggest__all" href="${seeAll}">${box.dataset.seeAll.replace('__TERMS__', term)}</a>` : ''}</div>` : `<p class="suggest__hint">${box.dataset.none.replace('__TERMS__', q)}</p>`}
          ${cols.length ? `<div><div class="suggest__head">${box.dataset.collections}</div>${cols.map((c) => `<a class="suggest__terms" href="${c.url}">${c.title}</a>`).join('')}</div>` : ''}`;
      } catch (e) { if (e.name !== 'AbortError') out.innerHTML = ''; }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
  });

  // ─── Collection filters: submit on change, keep the page where it is ──
  $$('form[data-filters]').forEach((form) => {
    form.addEventListener('change', () => { form.requestSubmit(); });
  });
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u; }));

  // ─── Reveals ─────────────────────────────────────────────
  const revealables = $$('.reveal');
  if (revealables.length && !reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    revealables.forEach((el) => io.observe(el));
  } else revealables.forEach((el) => el.classList.add('in'));
  // Pictures fade in as they arrive.
  const fadeIn = (img) => { if (img.complete) img.classList.add('is-loaded'); else img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true }); };
  $$('img.lazy-fade').forEach(fadeIn);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) $$('img.lazy-fade', n).forEach(fadeIn); }))).observe(document.body, { childList: true, subtree: true });

  // ─── The collection's filter bar: solid only while it is held at the top of the window ───
  $$('.toolbar').forEach((bar) => {
    const mark = document.createElement('div'); mark.setAttribute('aria-hidden', 'true'); mark.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none';
    bar.before(mark);
    // held = its marker has gone up under the header, which now stays at the top of the window
    const held = () => bar.classList.toggle('is-stuck', mark.getBoundingClientRect().top < (headerWrap ? headerWrap.getBoundingClientRect().bottom : 0) - 1);
    held(); addEventListener('scroll', held, { passive: true }); addEventListener('resize', held);
  });

  // ─── Collections in tabs: one collection's designs at a time ─────
  $$('[data-tabs]').forEach((box) => {
    const tabs = $$('[data-tab]', box), panels = $$('[data-panel]', box);
    const pick = (i) => { tabs.forEach((t, n) => t.setAttribute('aria-selected', String(n === i))); panels.forEach((p, n) => { p.hidden = n !== i; }); $$('.reveal', panels[i]).forEach((el) => el.classList.add('in')); };
    tabs.forEach((t, i) => { t.addEventListener('click', () => pick(i)); t.addEventListener('keydown', (e) => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; const n = (i + d + tabs.length) % tabs.length; pick(n); tabs[n].focus(); }); });
  });

  // ─── A product's photograph opened large ─────────────────
  const zoom = $('[data-zoom-dialog]');
  if (zoom && typeof zoom.showModal === 'function') {
    const big = $('[data-zoom-img]', zoom);
    $$('[data-zoom]').forEach((b) => b.addEventListener('click', () => { big.src = b.dataset.zoom; big.alt = $('img', b)?.alt || ''; zoom.showModal(); zoom.scrollTo(0, 0); }));
    const shut = () => zoom.close();
    $('[data-zoom-close]', zoom).addEventListener('click', shut); big.addEventListener('click', shut);
    zoom.addEventListener('close', () => big.removeAttribute('src'));
  }

  // ─── Recently viewed: kept in this browser only ──────────
  try {
    const KEY = 'sr-recent';
    const seen = JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => typeof h === 'string');
    const here = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    $$('[data-recent]').forEach((box) => {
      const list = seen.filter((h) => h !== here && h !== box.dataset.current).slice(0, Number(box.dataset.limit) || 4);
      if (!list.length) return;
      const grid = $('[data-recent-grid]', box), root = (SR.routes && SR.routes.root) || '/';
      Promise.all(list.map((h) => fetch(`${root}products/${h}?section_id=card-only`).then((r) => (r.ok ? r.text() : '')).catch(() => ''))).then((parts) => {
        parts.forEach((html) => { const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.card'); if (card) { $$('.reveal', card).forEach((el) => el.classList.add('in')); card.classList.add('in'); grid.append(card); } });
        if (grid.children.length) box.hidden = false;
      });
    });
    if (here && $('[data-product]')) localStorage.setItem(KEY, JSON.stringify([here, ...seen.filter((h) => h !== here)].slice(0, 8)));
  } catch (e) { /* private browsing: no row */ }

  // ─── The saints' line art behind the page ────────────────
  // One drawing to an open section, placed and sized here because only the browser knows how tall each
  // section is. The owner's rules (2026-10-04; snippets/ink-field.liquid has his words):
  //   · a drawing stands wholly inside one section's height, so none overlaps another or runs under a
  //     solid band; a section with a ground of its own (the black gift section, the promise bar) and
  //     the hero get none;
  //   · big, but never larger than its own large file;
  //   · it PEEPS in: set part way off the side of the window, which cuts it; the file itself is whole.
  //     A drawing marked whole (he gave it no side) is not cut;
  //   · sides alternate down the page, each figure on the side he gave it;
  //   · Saint Michael is the last drawing on the page, big, with his lowest third below the end of the
  //     page so the footer cuts him off;
  //   · a drawing may be given a size and a drop of its own (the owner's: Guadalupe smaller, Francis
  //     bigger and lower);
  //   · on a phone, each is set so that the saint's face is in the white space between two sections;
  //   · it is fetched only when about to be scrolled to.
  const inkField = $('.inkfield');
  if (inkField && 'IntersectionObserver' in window) {
    const main = inkField.parentElement;
    const last = $('[data-ink-last]', inkField);
    const queues = { left: $$('.ink--left:not([data-ink-last])', inkField), right: $$('.ink--right:not([data-ink-last])', inkField) };
    // Saint Michael stands on the side opposite the drawing above him (owner: "put Saint Michael on the bottom
    // right side because Saint Dominic above him is on the left side")
    const sideOfLast = (s) => { if (!last) return; last.classList.toggle('ink--left', s === 'left'); last.classList.toggle('ink--right', s === 'right'); };
    const PEEP = 0.26; // the part of a drawing's width that is off the side of the window
    const inkIO = new IntersectionObserver((es) => es.forEach((en) => { if (!en.isIntersecting) return; const im = en.target; if (im.dataset.inkSrcset) { im.srcset = im.dataset.inkSrcset; im.removeAttribute('data-ink-srcset'); } inkIO.unobserve(im); }), { rootMargin: '350px 0px' });
    const solid = (el) => { const c = getComputedStyle(el).backgroundColor; return c && c !== 'transparent' && !/, 0\)$/.test(c); };
    const SUNK = 1 / 3; // the part of Saint Michael that is below the end of the page, cut off by the footer
    const put = (im, slot, isLast) => {
      const natW = Number(im.getAttribute('width')), natH = Number(im.getAttribute('height'));
      const wide = innerWidth >= 900;
      const size = Number(im.dataset.inkSize) || 1, drop = Number(im.dataset.inkDrop) || 0;
      const maxW = wide ? Math.min(natW, innerWidth * 0.5) : innerWidth * 0.98;
      let h, top;
      if (isLast) {
        // as big as its width allows, its top two thirds standing in the last open stretch of the page and
        // the rest below that stretch's end, where whatever comes next cuts it off: the footer, or on an
        // apparel product page the black gift section ("make Saint Michael a bit bigger on the product
        // page in the bottom left, and cut off"). Never so tall that he reaches the drawing above him.
        h = Math.min(natH, maxW * natH / natW, (slot.runBottom - Math.max(slot.runTop, slot.ceiling || 0) - 24) / (1 - SUNK));
        top = slot.runBottom - h * (1 - SUNK);
      } else {
        // a bigger drawing may reach into the open sections around its own (never under a solid band), on a
        // wide screen only: on a phone the drawings are nearly the window's width and would cover each other
        const room = wide && size > 1 ? slot.runBottom - slot.runTop - 32 : slot.height - 40;
        h = Math.min(natH, Math.min(slot.height - 40, maxW * natH / natW) * size, room, maxW * Math.max(1, size) * natH / natW);
        top = slot.top + (slot.height - h) / 2 + drop * h;
        const lo = (wide && (size > 1 || drop) ? slot.runTop : slot.top) + 16, hi = (wide && (size > 1 || drop) ? slot.runBottom : slot.top + slot.height) - h - 16;
        top = Math.max(lo, Math.min(hi, top));
      }
      if (h < 240) return false;
      const w = h * natW / natH;
      im.style.setProperty('--h', `${Math.round(h)}px`);
      im.style.setProperty('--top', `${Math.round(top)}px`);
      im.style.setProperty('--side', im.hasAttribute('data-ink-whole') ? `${wide ? 24 : 8}px` : `${Math.round(-w * PEEP)}px`);
      // a phone is given the small file: at a tenth of full strength the large one is not worth its bytes
      im.sizes = `${Math.round(wide ? w : w * 0.5)}px`;
      im.classList.add('is-placed'); inkIO.observe(im);
      return true;
    };
    const place = () => {
      const top0 = main.getBoundingClientRect().top;
      const slots = [], gaps = []; let run = null, above = null;
      [...main.children].forEach((sec, n) => {
        if (sec === inkField) return;
        const inner = sec.firstElementChild || sec;
        const r = sec.getBoundingClientRect();
        // an open stretch of the page: sections one after another with no ground of their own
        if ((n <= 1 && $('.hero-wall, .hero', sec)) || solid(sec) || solid(inner)) { run = null; above = null; return; }
        if (!r.height) return;
        if (!run) run = { top: r.top - top0, bottom: r.bottom - top0 };
        run.bottom = r.bottom - top0;
        // the white space between two open sections: the foot of one's content to the head of the next's
        const cs = getComputedStyle(inner), padTop = parseFloat(cs.paddingTop) || 0, padBottom = parseFloat(cs.paddingBottom) || 0;
        if (above) { const from = above.bottom - above.padBottom, to = r.top - top0 + padTop; if (to - from >= 56) gaps.push({ y: (from + to) / 2, run }); }
        above = { bottom: r.bottom - top0, padBottom };
        // Measured as if its open panels were shut (owner, 2026-10-22: opening and closing The Story made Our Lady
        // beside the product grow, shrink and jump, "kind of like a glitch"), so a panel never changes a drawing's
        // size or its place beside the section; drawings further down still move with the page.
        const folded = $$('details[open]', sec).reduce((t, d) => { const s = $(':scope > summary', d); return t + Math.max(0, d.getBoundingClientRect().height - (s ? s.getBoundingClientRect().height : 0)); }, 0);
        const fh = r.height - folded;
        if (fh < 360) return;
        // a very tall section (a product page's main part, a long collection) takes more than one, well apart
        const count = Math.max(1, Math.min(4, Math.floor(fh / 1300)));
        const each = fh / count;
        for (let k = 0; k < count; k++) slots.push({ top: r.top - top0 + each * k, height: each, run });
      });
      const pageEnd = main.getBoundingClientRect().height;
      slots.forEach((slot) => { slot.runTop = slot.run.top; slot.runBottom = slot.run.bottom; slot.pageEnd = pageEnd; });
      $$('.ink.is-placed', inkField).forEach((im) => im.classList.remove('is-placed'));
      // the last slot is Saint Michael's; the others fill downwards, side by side in turn
      const lastSlot = last && slots.length > 1 ? slots.pop() : null;
      // which side the first drawing stands on is the page's to say (a product page starts on the left)
      const next = { left: 0, right: 0 }; let side = inkField.dataset.inkFirst === 'left' ? 'left' : 'right';
      if (innerWidth < 900) {
        // ON A PHONE the page has no empty margins, so a drawing mostly stands behind products and words.
        // What shows is the white space between sections, and the owner wants a saint's FACE there. Each
        // drawing is set so its face is in the middle of one such space, a little in from its own side.
        const vw = innerWidth; let floor = null;
        const chosen = [];
        gaps.forEach((g) => {
          let im = queues[side][next[side]];
          if (!im) { side = side === 'left' ? 'right' : 'left'; im = queues[side][next[side]]; if (!im) return; }
          chosen.push({ g, im, side }); next[side]++; side = side === 'left' ? 'right' : 'left';
        });
        sideOfLast(chosen.length ? side : 'left');
        if (lastSlot && put(last, lastSlot, true)) floor = { run: lastSlot.run, top: parseFloat(last.style.getPropertyValue('--top')) };
        // sized from the bottom of the page upwards, so each stops short of the one below it
        for (let i = chosen.length - 1; i >= 0; i--) {
          const { g, im, side: at } = chosen[i];
          const natW = Number(im.getAttribute('width')), natH = Number(im.getAttribute('height'));
          const [fx, fy] = (im.dataset.inkFace || '0.5x0.15').split('x').map(Number);
          const size = Math.min(1, Number(im.dataset.inkSize) || 1);
          let end = g.run.bottom - 16;
          if (floor && floor.run === g.run) end = Math.min(end, floor.top - 12);
          const h = Math.min(natH, vw * 0.98 * size * natH / natW, (end - g.y) / (1 - fy), (g.y - g.run.top - 8) / fy);
          if (h < 280) continue;
          const w = h * natW / natH, x = at === 'left' ? vw * 0.3 : vw * 0.7, top = g.y - fy * h;
          im.style.setProperty('--h', `${Math.round(h)}px`);
          im.style.setProperty('--top', `${Math.round(top)}px`);
          im.style.setProperty('--side', `${Math.round(at === 'left' ? x - fx * w : (vw - x) - (1 - fx) * w)}px`);
          im.sizes = `${Math.round(w * 0.5)}px`;
          im.classList.add('is-placed'); inkIO.observe(im);
          floor = { run: g.run, top };
        }
        return;
      }
      slots.forEach((slot) => {
        let im = queues[side][next[side]];
        if (!im) { side = side === 'left' ? 'right' : 'left'; im = queues[side][next[side]]; if (!im) return; }
        if (put(im, slot, false)) { next[side]++; side = side === 'left' ? 'right' : 'left'; }
      });
      if (lastSlot) {
        // the foot of the lowest drawing already standing on Saint Michael's side
        sideOfLast(side);
        lastSlot.ceiling = Math.max(0, ...$$(`.ink--${side}.is-placed`, inkField).map((im) => parseFloat(im.style.getPropertyValue('--top')) + parseFloat(im.style.getPropertyValue('--h'))));
        put(last, lastSlot, true);
      }
    };
    let inkTimer; const again = () => { clearTimeout(inkTimer); inkTimer = setTimeout(place, 150); };
    place(); addEventListener('load', again); addEventListener('resize', again);
    if ('ResizeObserver' in window) new ResizeObserver(again).observe(main);
    document.addEventListener('shopify:section:load', again);
  }

  // ─── The header's drop-down (Shop by Saint): hover and focus are CSS; a press toggles it for touch and keyboard ───
  $$('[data-navdrop]').forEach((btn) => {
    const box = btn.parentElement;
    const set = (open) => { box.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', () => set(!box.classList.contains('is-open')));
    document.addEventListener('click', (e) => { if (!box.contains(e.target)) set(false); });
    box.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); btn.focus(); } });
  });

  // ─── Instagram reels: a tile opens the video in a dialog; nothing loads until then ─────
  $$('[data-insta-player]').forEach((dlg) => {
    const video = $('video', dlg); const link = $('[data-insta-link]', dlg);
    const shut = () => { video.pause(); video.removeAttribute('src'); video.load(); };
    $$('[data-reel]', dlg.parentElement).forEach((tile) => tile.addEventListener('click', () => {
      if (typeof dlg.showModal !== 'function') { window.open(tile.dataset.link, '_blank', 'noopener'); return; }
      video.src = tile.dataset.video; if (tile.dataset.link) link.href = tile.dataset.link;
      dlg.showModal(); video.play().catch(() => {});
    }));
    $('[data-insta-close]', dlg).addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', shut);
  });

  // ─── Slideshow (the story section): one photograph at a time ─────
  $$('[data-slides]').forEach((box) => {
    const slides = $$('[data-slide]', box); if (slides.length < 2) return;
    const dots = $$('[data-slide-dot]', box.parentElement); const every = Number(box.dataset.interval) || 4000;
    let at = 0, timer = null, seen = false, held = false;
    // A later photograph has its address held back (data-src); it is given back one turn before it shows.
    const fetchPic = (i) => { const im = $('img[data-src]', slides[(i + slides.length) % slides.length]); if (!im) return; if (im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); im.loading = 'eager'; };
    const show = (i) => { fetchPic(i); fetchPic(i + 1); at = (i + slides.length) % slides.length; slides.forEach((s, n) => s.classList.toggle('is-on', n === at)); dots.forEach((d, n) => (n === at ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'))); };
    const stop = () => { clearInterval(timer); timer = null; };
    const play = () => { stop(); if (seen && !held && !reduce && SR.motion !== false) timer = setInterval(() => show(at + 1), every); };
    dots.forEach((d, i) => d.addEventListener('click', () => { show(i); play(); }));
    box.addEventListener('click', () => { show(at + 1); play(); });
    box.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { held = true; stop(); } });
    box.addEventListener('pointerleave', () => { held = false; play(); });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => es.forEach((en) => { seen = en.isIntersecting; if (seen) fetchPic(at + 1); play(); }), { threshold: .3 }).observe(box);
    else { seen = true; play(); }
    // In the theme editor, choosing a photo block shows it.
    document.addEventListener('shopify:block:select', (e) => { const i = slides.indexOf(e.target); if (i >= 0) { show(i); held = true; stop(); } });
    document.addEventListener('shopify:block:deselect', (e) => { if (slides.includes(e.target)) { held = false; play(); } });
  });

  // ─── Tilt under the pointer (desktop only) ───────────────
  if (SR.tilt !== false && !reduce && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointermove', (e) => {
      const card = e.target.closest('.tilt'); if (!card) return;
      const r = card.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.classList.add('is-tilting');
      card.style.setProperty('--ry', `${(x - .5) * 10}deg`); card.style.setProperty('--rx', `${(.5 - y) * 10}deg`);
      card.style.setProperty('--mx', `${x * 100}%`); card.style.setProperty('--my', `${y * 100}%`);
    });
    document.addEventListener('pointerout', (e) => { const card = e.target.closest('.tilt'); if (card && !card.contains(e.relatedTarget)) { card.classList.remove('is-tilting'); card.style.removeProperty('--rx'); card.style.removeProperty('--ry'); } });
  }

  // ─── Section rendering in the theme editor ───────────────
  document.addEventListener('shopify:section:load', () => { $$('.reveal').forEach((el) => el.classList.add('in')); });
})();
